<template>
  <FlexCol gap-3 class="h-full min-h-0">
    <Title :title="title" :breadcrumb="true">
      <Button label="Voltar" icon="fa-solid fa-arrow-left" primary @click="router.back()" />
    </Title>
    <slot name="middleCard"></slot>
    <Loader v-if="loader" />
    <Card variant="cockpit">
      <Accordion v-for="section in form" :key="section.section" :title="section.section" v-show="section.show === undefined ? true : !!section.show">
        <slot :name="`section-${section.id}`">
          <FlexCol gap-3>
            <Grid gap-3 cols-4>
              <FormField
                v-for="field in visibleFields(section.fields)"
                :key="field.name"
                :class="field.class || field.className"
                :style="field.style"
                v-model="object[field.name]"
                :label="field.label"
                :status="field.status"
                :type="field.type"
                :placeholder="field.placeholder"
                :options="field.options"
                :items="field.items"
                :database="field.database"
                :item-value="field.itemValue"
                :item-text="field.itemText"
                :clearable="field.clearable"
                :disabled="field.disabled"
                :required="field.required"
                :error="errors[field.name]" />
            </Grid>
          </FlexCol>
        </slot>
      </Accordion>

      <RequiredLabel class="py-3" />
      <Flex gap-2>
        <Button label="Salvar" icon="fa-solid fa-floppy-disk" primary @click="save" />
        <Button label="Cancelar" icon="fa-solid fa-x" danger @click="router.back()" id="backBtn" />
      </Flex>
    </Card>
  </FlexCol>
</template>

<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { insert, get, update } from '@/crud'

const props = defineProps({
  api: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  term: {
    type: String,
    default: null,
  },
  form: {
    type: Array,
    default: () => [],
  },
  idParam: {
    type: String,
    default: 'id',
  },
  idFilterColumn: {
    type: String,
    default: 'id',
  },
  updateIdField: {
    type: String,
    default: 'id',
  },
})
const emit = defineEmits(['update:modelValue'])

const router = useRouter()
const routeInfo = useRoute()

const route = ref(props.api)
const object = ref(props.modelValue)
const title = ref(props.title)
const errors = ref(props.errors)

const loader = ref(false)

const loadItem = async (id) => {
  loader.value = true
  const query = {
    params: {
      filters: [{ column: props.idFilterColumn, value: id }],
    },
  }
  const result = await get(route.value, query)
  object.value = result.data[0]
  loader.value = false
}

const save = async () => {
  loader.value = true
  let response
  const routeParamId = routeInfo.params[props.idParam]
  if (routeParamId) {
    const updateId = object.value?.[props.updateIdField] ?? routeParamId
    response = await update(route.value, updateId, object.value, props.term)
  } else {
    response = await insert(route.value, object.value, props.term)
  }

  loader.value = false
  errors.value = response.error ? response.data : {}
  if (!response.error) {
    router.back()
  }
}

const visibleFields = (fields = []) => fields.filter((field) => (field.show === undefined ? true : !!field.show))

watch(
  () => props.modelValue,
  (value) => {
    object.value = value || {}
  },
  { deep: true },
)

watch(
  object,
  (value) => {
    emit('update:modelValue', value)
  },
  { deep: true },
)

onMounted(async () => {
  const id = routeInfo.params[props.idParam]
  if (id) {
    await loadItem(id)
  }

  title.value = id ? `Edição de ${props.title}` : `Cadastro de ${props.title}`
})
</script>
